/**
 * In-memory token store.
 *
 * Tokens are held in module-scoped variables rather than localStorage,
 * so they are never persisted to disk and cannot be read by XSS payloads
 * that scan Storage.  The trade-off is that a full page refresh clears
 * the session (the user will need to re-authenticate).
 */

import type { TokenMeta } from './authService';

let _accessToken: string | null = null;
let _tokenMeta: TokenMeta | null = null;

/** Return the current access token (null if not set). */
export function getToken(): string | null {
  return _accessToken;
}

/** Store an access token (without the "Bearer " prefix). */
export function setToken(token: string): void {
  _accessToken = token;
}

/** Return the stored token metadata (null if not set). */
export function getTokenMeta(): TokenMeta | null {
  return _tokenMeta;
}

/** Store token metadata alongside the access token. */
export function setTokenMeta(meta: TokenMeta): void {
  _tokenMeta = meta;
}

/** Clear both the token and its metadata (logout). */
export function clearToken(): void {
  _accessToken = null;
  _tokenMeta = null;
}
